import type { StatusVariant } from '@/types/status.types'
import type { Theme } from '@mui/material/styles'
import { blackVariants, blueDeepVariants, limeGreenVariants } from '@/themes/colors.ts'

export const getStatusColors = (variant: StatusVariant, theme: Theme) => {
  switch (variant) {
    case 'default':
      return {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.grey['100']
      }
    case 'highlight':
      return {
        color: blueDeepVariants['900'],
        backgroundColor: limeGreenVariants['300']
      }
    case 'success':
      return {
        backgroundColor: theme.palette.success?.light || '#4caf50',
        color:
          theme.palette.success?.dark ||
          theme.palette.getContrastText?.(theme.palette.success?.light || '#4caf50') ||
          '#fff'
      }
    case 'info':
      return {
        backgroundColor: theme.palette.info?.light || '#2196f3',
        color:
          theme.palette.info?.dark ||
          theme.palette.getContrastText?.(theme.palette.info?.light || '#2196f3') ||
          '#fff'
      }
    case 'warning':
      return {
        backgroundColor: theme.palette.warning?.light || '#ff9800',
        color:
          theme.palette.warning?.dark ||
          theme.palette.getContrastText?.(theme.palette.warning?.light || '#ff9800') ||
          '#000'
      }
    case 'error':
      return {
        backgroundColor: theme.palette.error?.light || '#f44336',
        color:
          theme.palette.error?.dark ||
          theme.palette.getContrastText?.(theme.palette.error?.light || '#f44336') ||
          '#fff'
      }
    case 'inactive':
      return {
        color: blueDeepVariants['900'],
        backgroundColor: blackVariants['300']
      }
    default:
      return {
        backgroundColor: theme.palette.success?.light || '#4caf50',
        color:
          theme.palette.success?.dark ||
          theme.palette.getContrastText?.(theme.palette.success?.light || '#4caf50') ||
          '#fff'
      }
  }
}

export const getAlertColors = (severity: StatusVariant, theme: Theme) => {
  const statusColors = getStatusColors(severity, theme)

  return {
    backgroundColor: statusColors.backgroundColor, // Add opacity
    borderColor: statusColors.color,
    iconColor: statusColors.color
  }
}
